import { request } from "./http";

export interface AuditEvent {
  id: number;
  org_id: string;
  user_id: string | null;
  actor_type: string;
  actor_id: string | null;
  action: string;
  resource_type: string | null;
  resource_id: string | null;
  ip: string | null;
  user_agent: string | null;
  payload: Record<string, unknown>;
  created_at: string;
}

export interface AuditPage {
  items: AuditEvent[];
  next_cursor: number | null;
}

export const audit = {
  list: (params: {
    from?: string;
    to?: string;
    action?: string;
    resource_type?: string;
    actor_type?: string;
    search?: string;
    limit?: number;
    cursor?: number;
  } = {}) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== "") qs.set(k, String(v));
    }
    return request<AuditPage>(`/api/v1/audit${qs.toString() ? "?" + qs : ""}`);
  },
};
